<template>
  <InputText :rules="rules" />
</template>

<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import InputText from "@/components/common/fields/InputText.vue";

const { t } = useI18n();

const rules = ref([
    (value) => {
        if (!value) return true

        const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        return pattern.test(value) || t("common.messages.validations.invalidEmail")
    },
])
</script>
